<div class="margin-top-lg">
    <mat-card-title>
        <div class="row">
            <div class="col-4">Course History</div>
            <mat-icon *ngIf="isLoading">
                <mat-spinner *ngIf="isLoading" diameter="30"></mat-spinner>
            </mat-icon>

            <div class="col-8" *ngIf="editing">
                <button *ngIf="addAccess" mat-raised-button color="primary" class="button-add-row" (click)="addRow()">
                    Add Course History
                </button>
            </div>
        </div>
    </mat-card-title>
    <div class="row" style="padding-top: 5px;">
        <div class="col">
            <mat-divider></mat-divider>
        </div>
    </div>
    {{ boolFoundCourseHistory ==false ? studentName + ' does not have any Course Histories.' : '' }}
    <div *ngFor="let item of lstRegionbyGroup">
        <div style="padding-top: 10px" *ngIf="item.editableCH[0].courseHistory.REGION.ID == this.userRegion.ID">
            <app-course-history-table (modificationEvent)="invokeApiGetCourseHistory($event)"
                [courseHistories]="item.editableCH" [studentId]="studentId"
                [editing]="editing"></app-course-history-table>
        </div>
    </div>
    <div *ngFor="let item of lstRegionbyGroup">
        <div *ngIf="item.editableCH[0].courseHistory.REGION.ID != this.userRegion.ID">
            <app-course-history-table (modificationEvent)="invokeApiGetCourseHistory($event)"
                [courseHistories]="item.editableCH" [studentId]="studentId"
                [editing]="editing"></app-course-history-table>
        </div>

    </div>
</div>